import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  UPDATE_BOOKING,
  CANCEL_BOOKING
} from "../store/types";

const INITIAL_STATE = {
  bookings: null,
  active: null,
  tracked: null,
  loading: false,
  // 'uid:role' the last fetch RESULT (SUCCESS or FAILED) was for. For
  // drivers/customers an empty snapshot dispatches FAILED, which resets
  // `active` to null — the same value as "no result yet". This stamp lets
  // AppNavigator's cold-start onboarding guard tell "no result yet" from "no
  // bookings" for the signed-in account (a never-booked account must still be
  // gated), survives a navigator remount, and never matches a previous
  // account's list. Nothing else reads it.
  fetchedFor: null,
  error: {
    flag: false,
    msg: null
  }
}

export const bookingslistreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BOOKINGS:
      return {
        ...state,
        loading: true
      };
    case FETCH_BOOKINGS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        fetchedFor: action.fetchedFor || state.fetchedFor || null
      };
    case FETCH_BOOKINGS_FAILED:
      return {
        ...state,
        bookings: null,
        active:null,
        tracked:null,
        loading: false,
        fetchedFor: action.fetchedFor || state.fetchedFor || null,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case UPDATE_BOOKING:
      return {
        ...state
      }      
    case CANCEL_BOOKING:
      return {
        ...state
      };
    default:
      return state;
  }
};